import { CSSProperties } from 'react';

import NextImage from 'next/image';

import { MapboxAttribution } from '../MapboxAttribution/MapboxAttribution';
import { getStaticWaterMap, MapStyle } from '../Maps/mapData/staticMaps';
import { StaticMapPlaceholder } from '../Placeholder/StaticMapPlaceholder';

interface IProps {
  longitude: string;
  latitude: string;
  alt?: string;
  width?: number;
  height?: number;
  mapStyle?: MapStyle;
  style?: CSSProperties;
}

const DEFAULT_WIDTH = 200;
const DEFAULT_HEIGHT = 150;

export const WaterImage = ({
  longitude,
  latitude,
  alt,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  mapStyle,
  style,
}: IProps) => {
  return (
    <div
      style={style ?? { minHeight: height, minWidth: width }}
      className="relative inline-block w-full"
    >
      <StaticMapPlaceholder />
      <NextImage
        alt={alt ?? `Longitude: ${longitude}, Latitude: ${latitude}`}
        className="bg-twilight-pulse absolute top-0 left-0 size-full rounded-md object-center md:rounded-lg"
        src={getStaticWaterMap(longitude, latitude, width, height, mapStyle)}
        width={width}
        height={height}
        unoptimized
      />
      <MapboxAttribution isLinked={false} />
    </div>
  );
};
